import { render } from "./UpdateCompanyInfo.vue?vue&type=template&id=5f2228de&scoped=true&ts=true"
import script from "./UpdateCompanyInfo.vue?vue&type=script&lang=ts"
export * from "./UpdateCompanyInfo.vue?vue&type=script&lang=ts"

import "./UpdateCompanyInfo.vue?vue&type=style&index=0&id=5f2228de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2228de"]])

export default __exports__